// imports stream: Import workspace keys (en/es). Merged into the app dictionary by locales/index.ts.
export const en: Record<string, string> = {
  "import.title": "Import & migration",
  "import.subtitle": "Bring customers and policies in from an export. Every count comes from actual processing.",
  "import.new": "New import",
  "import.history": "Import history",
  "import.none": "No imports yet.",
  "import.sourceSystem": "Source system",
  "import.sourceSystem.help": "A short name for where the file came from (used to remember ids and mappings).",
  "import.file": "Export file (CSV)",
  "import.useSample": "Use sample",
  "import.samples": "Demonstration exports",
  "import.samples.sub": "Two differently structured fictional exports that go through the same pipeline. Not an Agency Matrix schema.",
  "import.upload": "Upload and preview",
  "import.uploading": "Uploading…",
  "import.rows": "rows",
  "import.columns": "columns",
  "import.status.uploaded": "Uploaded",
  "import.status.mapped": "Mapped",
  "import.status.validated": "Validated",
  "import.status.imported": "Imported",
  "import.status.failed": "Failed",
  "import.step.preview": "Preview",
  "import.step.map": "Map columns",
  "import.step.validate": "Validate",
  "import.step.review": "Review",
  "import.step.import": "Import",
  "import.step.done": "Done",
  "import.preview.title": "What the file contains",
  "import.preview.sub": "First 20 rows, exactly as read.",
  "import.duplicate": "This exact file was already imported as batch {id}. Re-running updates what changed and never duplicates.",
  "import.map.title": "Map columns to fields",
  "import.map.sub": "Suggestions are prefilled from the header names. Required: a customer name; for policies, carrier, policy number, effective and expiration dates.",
  "import.map.target": "Field",
  "import.map.column": "Column in file",
  "import.map.unmapped": "— not mapped —",
  "import.map.required": "required",
  "import.map.dateFormat": "Date format",
  "import.map.date.auto": "Detect",
  "import.map.date.MDY": "M/D/YYYY",
  "import.map.date.DMY": "D/M/YYYY",
  "import.map.date.YMD": "YYYY-MM-DD",
  "import.map.carrierDefault": "Default carrier (when no column)",
  "import.map.saveAs": "Save this mapping as…",
  "import.map.saveName": "Mapping name",
  "import.map.saved": "Saved mappings",
  "import.map.apply": "Apply mapping",
  "import.map.save": "Save mapping and continue",
  "import.map.useSuggested": "Use suggestions",
  "import.validate.run": "Validate (dry run)",
  "import.validate.running": "Validating…",
  "import.validate.title": "What would happen",
  "import.validate.sub": "Every row was run through the real rules. Nothing has been written yet.",
  "import.coverage.title": "Migration coverage",
  "import.coverage.sub": "Only what this file actually contains. A contact export does not carry history.",
  "import.coverage.customers": "Customers",
  "import.coverage.policies": "Policies",
  "import.coverage.notes": "Notes",
  "import.coverage.attachments": "Attachments",
  "import.coverage.priorTerms": "Prior terms",
  "import.coverage.history": "Activity history",
  "import.coverage.present": "in this file",
  "import.coverage.absent": "not in this file",
  "import.counts.newCustomers": "New customers",
  "import.counts.newPolicies": "New policies",
  "import.counts.updCustomers": "Customers updated",
  "import.counts.updPolicies": "Policies updated",
  "import.counts.skips": "Duplicates skipped",
  "import.counts.exceptions": "Need review",
  "import.counts.unchanged": "Unchanged",
  "import.rows.title": "Row outcomes",
  "import.rows.all": "All outcomes",
  "import.outcome.create": "Create",
  "import.outcome.update": "Update",
  "import.outcome.skip_duplicate": "Duplicate",
  "import.outcome.exception": "Review",
  "import.outcome.unchanged": "Unchanged",
  "import.rows.row": "Row",
  "import.rows.reason": "Reason / note",
  "import.rows.record": "Record",
  "import.commit": "Import {n} rows",
  "import.commit.blocked": "Rows that need review are skipped; everything else imports.",
  "import.committing": "Importing…",
  "import.done.title": "Imported",
  "import.done.sub": "Records are in the book. Counts below are from actual processing.",
  "import.done.openCustomers": "Open customers",
  "import.done.customers": "customers touched",
  "import.done.policies": "policies touched",
  "import.done.notes": "notes created",
  "import.warnings": "Warnings",
  "import.revalidate": "Validate again",
  "import.back": "Back to imports",
  "import.openCustomer": "Open customer",
  "import.mapping.builtin": "built-in",
  "import.origin.upload": "Upload",
  "import.origin.carrier_request": "Carrier download",
  "import.origin.sample": "Sample",
};

export const es: Record<string, string> = {
  "import.title": "Importar y migrar",
  "import.subtitle": "Trae clientes y pólizas desde una exportación. Cada cifra viene del procesamiento real.",
  "import.new": "Nueva importación",
  "import.history": "Historial de importaciones",
  "import.none": "Aún no hay importaciones.",
  "import.sourceSystem": "Sistema de origen",
  "import.sourceSystem.help": "Nombre corto de dónde viene el archivo (se usa para recordar ids y mapeos).",
  "import.file": "Archivo exportado (CSV)",
  "import.useSample": "Usar muestra",
  "import.samples": "Exportaciones de demostración",
  "import.samples.sub": "Dos exportaciones ficticias con estructuras distintas que pasan por el mismo proceso. No es el esquema de Agency Matrix.",
  "import.upload": "Subir y previsualizar",
  "import.uploading": "Subiendo…",
  "import.rows": "filas",
  "import.columns": "columnas",
  "import.status.uploaded": "Subido",
  "import.status.mapped": "Mapeado",
  "import.status.validated": "Validado",
  "import.status.imported": "Importado",
  "import.status.failed": "Falló",
  "import.step.preview": "Vista previa",
  "import.step.map": "Mapear columnas",
  "import.step.validate": "Validar",
  "import.step.review": "Revisar",
  "import.step.import": "Importar",
  "import.step.done": "Listo",
  "import.preview.title": "Qué contiene el archivo",
  "import.preview.sub": "Primeras 20 filas, tal como se leyeron.",
  "import.duplicate": "Este mismo archivo ya se importó como lote {id}. Repetirlo actualiza lo que cambió y nunca duplica.",
  "import.map.title": "Mapear columnas a campos",
  "import.map.sub": "Las sugerencias vienen de los encabezados. Obligatorio: un nombre de cliente; para pólizas, aseguradora, número, fecha de inicio y de vencimiento.",
  "import.map.target": "Campo",
  "import.map.column": "Columna en el archivo",
  "import.map.unmapped": "— sin mapear —",
  "import.map.required": "obligatorio",
  "import.map.dateFormat": "Formato de fecha",
  "import.map.date.auto": "Detectar",
  "import.map.date.MDY": "M/D/AAAA",
  "import.map.date.DMY": "D/M/AAAA",
  "import.map.date.YMD": "AAAA-MM-DD",
  "import.map.carrierDefault": "Aseguradora por defecto (si no hay columna)",
  "import.map.saveAs": "Guardar este mapeo como…",
  "import.map.saveName": "Nombre del mapeo",
  "import.map.saved": "Mapeos guardados",
  "import.map.apply": "Aplicar mapeo",
  "import.map.save": "Guardar mapeo y continuar",
  "import.map.useSuggested": "Usar sugerencias",
  "import.validate.run": "Validar (simulación)",
  "import.validate.running": "Validando…",
  "import.validate.title": "Qué pasaría",
  "import.validate.sub": "Cada fila pasó por las reglas reales. Todavía no se escribió nada.",
  "import.coverage.title": "Cobertura de la migración",
  "import.coverage.sub": "Solo lo que este archivo contiene. Una exportación de contactos no trae historial.",
  "import.coverage.customers": "Clientes",
  "import.coverage.policies": "Pólizas",
  "import.coverage.notes": "Notas",
  "import.coverage.attachments": "Adjuntos",
  "import.coverage.priorTerms": "Vigencias anteriores",
  "import.coverage.history": "Historial de actividad",
  "import.coverage.present": "en este archivo",
  "import.coverage.absent": "no está en este archivo",
  "import.counts.newCustomers": "Clientes nuevos",
  "import.counts.newPolicies": "Pólizas nuevas",
  "import.counts.updCustomers": "Clientes actualizados",
  "import.counts.updPolicies": "Pólizas actualizadas",
  "import.counts.skips": "Duplicados omitidos",
  "import.counts.exceptions": "Por revisar",
  "import.counts.unchanged": "Sin cambios",
  "import.rows.title": "Resultado por fila",
  "import.rows.all": "Todos",
  "import.outcome.create": "Crear",
  "import.outcome.update": "Actualizar",
  "import.outcome.skip_duplicate": "Duplicado",
  "import.outcome.exception": "Revisar",
  "import.outcome.unchanged": "Sin cambios",
  "import.rows.row": "Fila",
  "import.rows.reason": "Motivo / nota",
  "import.rows.record": "Registro",
  "import.commit": "Importar {n} filas",
  "import.commit.blocked": "Las filas por revisar se omiten; todo lo demás se importa.",
  "import.committing": "Importando…",
  "import.done.title": "Importado",
  "import.done.sub": "Los registros ya están en la cartera. Las cifras vienen del procesamiento real.",
  "import.done.openCustomers": "Abrir clientes",
  "import.done.customers": "clientes afectados",
  "import.done.policies": "pólizas afectadas",
  "import.done.notes": "notas creadas",
  "import.warnings": "Avisos",
  "import.revalidate": "Validar de nuevo",
  "import.back": "Volver a importaciones",
  "import.openCustomer": "Abrir cliente",
  "import.mapping.builtin": "integrado",
  "import.origin.upload": "Subida",
  "import.origin.carrier_request": "Descarga de aseguradora",
  "import.origin.sample": "Muestra",
};
